module.exports = __webpack_public_path__ + "static/media/boji.cae53bdb.jpeg";